import { z } from 'zod';
import { startOfYear } from 'date-fns';

export const sessionsReportGroupByEnum = z.enum(['course', 'month', 'instructor', 'none']);

export const sessionsReportStatusEnum = z.enum(['pending', 'in_progress', 'completed']);

export const sessionsReportFilterSchema = z.object({
  search: z.string().optional(),
  courseId: z.string().optional(),
  instructorUserId: z.string().optional(),
  status: sessionsReportStatusEnum.optional(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  groupBy: sessionsReportGroupByEnum.optional(),
  userId: z.string().optional(),
});

export type SessionsReportFilterValues = z.infer<typeof sessionsReportFilterSchema>;

export const sessionsReportFilterDefaults: SessionsReportFilterValues = {
  search: '',
  courseId: undefined,
  instructorUserId: undefined,
  status: undefined,
  startDate: startOfYear(new Date()),
  endDate: new Date(),
  groupBy: 'course',
  userId: undefined,
};
